import { render, staticRenderFns } from "./FileStructuralReportCard.vue?vue&type=template&id=0ed02ce8"
import script from "./FileStructuralReportCard.vue?vue&type=script&lang=ts"
export * from "./FileStructuralReportCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports